import { Flex, Box } from 'components/ui';
import { Row, Col } from 'react-grid-system';
import RoundedBox from 'components/Traits/RoundedBox';
import TraitsGallery from 'components/TraitsGallery';
import spiralIcon from 'img/spiral.svg';
import { TRAITS_MEDIA_FILES } from '../../constants';

interface TwistsAndDistortionsProps {}

const TwistsAndDistortions: React.FC<TwistsAndDistortionsProps> = () => {
  return (
    <Row>
      <Col xs={12} sm={12} md={5}>
        <RoundedBox>
          <TraitsGallery
            items={[
              {
                title: '1 Twist',
                content: (
                  <Box>
                    <img
                      src={TRAITS_MEDIA_FILES.twists[1]}
                      width="100%"
                      alt="1 twist"
                    />
                  </Box>
                ),
                description: 'Generation 0 (Futura Master) has 1 twist.',
              },
              {
                title: '3 Twists',
                content: (
                  <Box>
                    <img
                      src={TRAITS_MEDIA_FILES.twists[3]}
                      width="100%"
                      alt="3 twists"
                    />
                  </Box>
                ),
                description: 'Generation 1 (Futura Mix) has 3 twists.',
              },
              {
                title: '5 Twists',
                content: (
                  <Box>
                    <img
                      src={TRAITS_MEDIA_FILES.twists[5]}
                      width="100%"
                      alt="5 twists"
                    />
                  </Box>
                ),
                description: 'Generation 2 on (Futura Remix) has 5 twists.',
              },
              {
                title: 'Distortion',
                content: (
                  <Box>
                    <img
                      src={TRAITS_MEDIA_FILES.twists.distortion}
                      width="100%"
                      alt="Distortion"
                    />
                  </Box>
                ),
                description: 'A distortion causes the notes not to follow the band’s rotation axis',
              },
            ]}
          />
        </RoundedBox>
      </Col>

      <Col xs={12} sm={12} md={7}>
        <RoundedBox maxHeight="565px" overflowY="scroll">
          <Flex mb={3}>
            <img src={spiralIcon} width="20px" alt="note shape icon" />
            <Box ml={3} fontWeight="bold" fontSize={3}>
              Twists and Distortion
            </Box>
          </Flex>

          <Box fontWeight="bold" mb={2}>
            TWIST
          </Box>
          <Box>
            <ul>
              <li>
                A Möbius strip can be created by taking a strip and giving it an odd number of
                half-twists, then taping the ends back together to form a loop. So technically,
                möbius must have only an odd number of twists. The Futura NFT adopts the more
                predominant Twist among its clips.
                <ul>
                  <li>
                    As a fun addition, we included into the code the possibility of some mobius
                    having even number of twists (those are very rare).
                  </li>
                </ul>
              </li>
              <li>
                The Möbius strip is built up from the source musical Clips and displays the current
                play-status of the musical piece. This moves in real time as the music plays.
              </li>
              <li>
                There is a correlation between two global traits: number of Twists and the
                Generation.
                <ul>
                  <li>Generation 0 (Futura Master) has 1 twist.</li>
                  <li>Generation 1 (Futura Mix) has 3 twists.</li>
                  <li>Generation 2 on (Futura Remix) has 5 twists. </li>
                  <li>
                    Note: There is a low chance for a Futura NFT to have one less twist than normal.
                    For instance, in a rare occasion a Generation 1 could have 2 twists, or a
                    Generation 2 could have 4 twists.{' '}
                  </li>
                </ul>
              </li>
            </ul>

            <Box fontWeight="bold" mb={2}>
              DISTORTION
            </Box>
            <ul>
              <li>
                When a Futura NFT has a distortion the notes will not follow the same rotation axis
                as the band. They will be slightly offset.
              </li>
              <li>There is a very low chance that a Futura has a distortion as an attribute. </li>
            </ul>
          </Box>
        </RoundedBox>
      </Col>
    </Row>
  );
};

export default TwistsAndDistortions;
